import { render, staticRenderFns } from "./xero.vue?vue&type=template&id=ddbae17a&scoped=true"
import script from "./xero.vue?vue&type=script&lang=js"
export * from "./xero.vue?vue&type=script&lang=js"
import style0 from "./xero.vue?vue&type=style&index=0&id=ddbae17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbae17a",
  null
  
)

export default component.exports